import { __awaiter } from "tslib";
/**
 * Intent.ts
 * @author Diao Zheng
 * @file Intent
 * @barrel export all
 */
import _ from "lodash";
import { Dev, Option } from "nasi";
export function NoUpdate() {
    return null;
}
export function Update(update) {
    // implicitly converting a Pick to a Partial
    return { update };
}
export function SideEffects(...effect) {
    return { effect };
}
export function UpdateWithSideEffects(update, ...effect) {
    return { update, effect };
}
export function Reduce(left, right) {
    const lhs = Option.wrapNotNull(left);
    const rhs = Option.wrapNotNull(right);
    if (Option.isNone(lhs)) {
        return right;
    }
    if (Option.isNone(rhs)) {
        return left;
    }
    const update = lhs.update ?
        _.merge(lhs.update, rhs.update)
        :
            rhs.update;
    const effect = lhs.effect ?
        rhs.effect ?
            _.concat(lhs.effect, rhs.effect)
            :
                lhs.effect
        :
            rhs.effect;
    return { update, effect };
}
/**
 * Returns a side effect that prints the following message if compareValue is
 * oldAction (=== comparison).
 *
 * >  Action "{oldAction}" is deprecated in {component}. Use "{replaceWith}"
 * >  instead.
 *
 * @param compareValue the value to compare to (usually action.action)
 * @param oldAction the old action string to deprecate.
 * @param component the component name, for yellow box.
 * @param replaceWith the new action which should be used.
 */
export function printDeprecationMessage(compareValue, oldAction, component, replaceWith) {
    return Dev.select(() => () => __awaiter(this, void 0, void 0, function* () {
        if (compareValue === oldAction) {
            // tslint:disable-next-line:no-console
            console.warn(`Action "${oldAction}" is deprecated in ${component}.` +
                (replaceWith ?
                    ` Use "${replaceWith}" instead.`
                    :
                        ""));
        }
    }), () => () => Promise.resolve(undefined));
}
